export default __webpack_public_path__ + "static/media/headshot.9c4a340c.jpg";